import { connect } from 'react-redux'
import { IRootReducerState } from 'state/reducers'

const mapStateToProps = (state: IRootReducerState) => ({
  authenticated: state.auth.authenticated
})

const withAuthenticated = connect(mapStateToProps)

export default withAuthenticated
